module.exports = __webpack_public_path__ + "media/images/gallery-image1-38bef06fd50e8a0b357ec5210c7580cb.webp";